export const LocaleSegmentRegex = /^\/([a-z]{2})-([a-z]{2})/i
